export const BASE_URI = "https://social-minds-backend.onrender.com"
// export const BASE_URI = "https://social-minds-backend-production.up.railway.app"
// export const BASE_URI = "http://localhost:3001"